import React, { useState, useEffect } from 'react';

export const CountdownTimer = ({ endTime }) => {
    const calculateTimeLeft = () => {
        const now = new Date();
        const end = new Date(endTime);

        const difference = end.getTime() - now.getTime();
        let timeLeft = {};

        if (difference > 0) {
            timeLeft = {
                hours: Math.floor(difference / (1000 * 60 * 60)),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        } else {
             timeLeft = { hours: 0, minutes: 0, seconds: 0 };
        }
        return timeLeft;
    };

    const padWithZero = (number) => {
        return String(number).padStart(2, '0');
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearTimeout(timer);
    }, [timeLeft]);

    const { hours, minutes, seconds } = timeLeft;
    const isTimeUp = hours === 0 && minutes === 0 && seconds === 0;

    return (
        <div>
            {isTimeUp ? ( 
                <span>Время вышло!</span> 
            ) : ( 
                <span>
                    {hours > 0 && `${padWithZero(hours)} ч `}
                    {minutes > 0 && `${padWithZero(minutes)} мин `}
                    {`${padWithZero(seconds)} сек`}
                </span>
            )}
        </div>
    );
};